import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/open')({
  ssr: false,
});
